import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ModalitySpotlight = () => {
  const [m, setM] = useState(null);

  useEffect(() => {
    api.get("/learn/spotlight").then((r) => setM(r.data)).catch(() => setM(null));
  }, []);

  if (!m) return null;
  const browseHref = m.browse ? `/browse?category=${m.browse.category_id}&subcategory=${m.browse.subcategory_id}` : "/browse";

  return (
    <section className="border-y border-border/60 bg-card/20" data-testid="modality-spotlight">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 items-center">
        <Link to={`/learn/${m.slug}`} className="group relative block rounded-lg overflow-hidden silk-card aspect-[3/2]" data-testid="modality-spotlight-image-link">
          <img src={m.image} alt={m.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
          <span className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.25em] text-foreground/90 bg-background/60 backdrop-blur-md rounded-full px-3 py-1.5">
            Week {m.week}
          </span>
        </Link>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-3 flex items-center gap-2"><BookOpen size={13} /> Modality of the week</p>
          <h2 className="font-display text-3xl sm:text-4xl text-foreground mb-3" data-testid="modality-spotlight-title">{m.title}</h2>
          <p className="text-sm text-muted-foreground mb-4">{m.summary}</p>
          <p className="text-sm text-foreground/80 leading-relaxed mb-8" data-testid="modality-spotlight-teaser">{m.teaser}</p>
          <div className="flex flex-wrap gap-3">
            <Button asChild className="rounded-full px-6" data-testid="modality-spotlight-read-btn">
              <Link to={`/learn/${m.slug}`}>Read in the Learn Library <ArrowRight size={14} className="ml-2" /></Link>
            </Button>
            {m.related_subcategory && (
              <Button asChild variant="outline" className="rounded-full px-6" data-testid="modality-spotlight-browse-btn">
                <Link to={browseHref}>Find {m.related_subcategory} practitioners</Link>
              </Button>
            )}
          </div>
          <p className="text-xs text-muted-foreground mt-6">A new modality every week — <Link to="/learn" className="text-primary hover:underline">explore the whole library</Link>.</p>
        </div>
      </div>
    </section>
  );
};
